import Vue from 'vue';
const resource = '/users';

export default {
  // CUSTOM ENDPOINT
  getWithConfig(idPublic) {
    return Vue.prototype.$axiosMainClient.get(
      `${resource}/${idPublic}?include=config`
    );
  },
  
  setUserLastSeenBuildNumber(idPublic) {
    return Vue.prototype.$axiosMainClient.post(
      `${resource}/setUserLastSeenBuildNumber=${idPublic}`
    );
  }
};
